import { __read, __spreadArray } from "tslib";
import * as Commands from "./Commands/index.mjs";
import * as Numerics from "./Numerics/index.mjs";
export { Commands, Numerics };
export var all = new Map(__spreadArray(__spreadArray([], __read(Object.values(Commands))), __read(Object.values(Numerics))).map(function (cmd) { return [cmd.COMMAND, cmd]; }));
